import React from 'react';
import CategoriesList from 'src/components/categories-list';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';

export default function CategoriesPage() {
  return <CategoriesList />;
}

CategoriesPage.layout = MainDispensaryLayout;
